import { EntityDetailViewProps } from "../common/entity/EntityInterfaces";
import { EntityDetailPage, EntityDetailView } from "../common/entity/EntityDetailPage";
import { MethodsDetail } from "./MethodsDetail";
import { EntityTablePage } from "../common/entity/EntityTablePage";
import { MethodsTable } from "./Table/MethodsTable";

// Detail
export const MethodsDetailView = ({ id }: EntityDetailViewProps<"methods">) => {
  return (
    <EntityDetailView id={id} entityTypeId="methods" filters={{}}>
      {(props) => <MethodsDetail {...props} />}
    </EntityDetailView>
  );
};

export const MethodDetailsPage = () => {
  return <EntityDetailPage<"methods"> isIntId={false}>{(id) => <MethodsDetailView id={id} />}</EntityDetailPage>;
};

export const MethodsTablePage = () => {
  return <EntityTablePage entityTypeId="methods">{(props) => <MethodsTable {...props} />}</EntityTablePage>;
};
